document.addEventListener('DOMContentLoaded', () => {
    const canvas = document.querySelector('[data-own-funds-chart]');
    if (!canvas) return;

    const values = JSON.parse(canvas.dataset.values || '[]');
    if (values.every((value) => value <= 0)) return;

    const styles = getComputedStyle(document.documentElement);
    const colors = [
        styles.getPropertyValue('--color-maleish').trim(),
        styles.getPropertyValue('--color-femaleish').trim(),
    ];

    new Chart(canvas.getContext('2d'), {
        type: 'pie',
        data: {
            labels: JSON.parse(canvas.dataset.labels || '[]'),
            datasets: [{
                data: values,
                backgroundColor: colors,
                borderColor: colors,
                borderWidth: 2,
            }],
        },
        options: {
            responsive: true,
            maintainAspectRatio: false,
            legend: {
                display: false,
            },
        },
    });
});
